export default {"src":"/_next/static/media/aiGlasses.816bec9a.gif","height":250,"width":250,"blurWidth":0,"blurHeight":0};